export const heroUIConfig = {
  // Глобальные настройки accessibility для HeroUI компонентов
  defaultProps: {
    Button: {
      'aria-label': 'Кнопка',
    },
    Chip: {
      'aria-label': 'Статус',
    },
    Badge: {
      'aria-label': 'Индикатор',
    },
    Avatar: {
      'aria-label': 'Аватар пользователя',
    },
    ScrollShadow: {
      'aria-label': 'Прокручиваемая область',
    },
    Input: {
      'aria-label': 'Поле ввода',
    },
    Tab: {
      'aria-label': 'Вкладка',
    }
  }
};

// Функция для применения aria-label к компонентам без видимого текста
export const addMissingAriaLabels = () => {
  // Добавляем aria-label к элементам без видимого текста после рендера
  setTimeout(() => {
    try {
      // Кнопки без текста
      document.querySelectorAll('button:not([aria-label]):not([aria-labelledby])').forEach(button => {
        if (!button.textContent?.trim()) {
          button.setAttribute('aria-label', 'Кнопка интерфейса');
        }
      });

      // Элементы с ролью tab без aria-label
      document.querySelectorAll('[role="tab"]:not([aria-label]):not([aria-labelledby])').forEach(tab => {
        if (!tab.textContent?.trim()) {
          tab.setAttribute('aria-label', 'Вкладка навигации');
        }
      });

      // Элементы с ролью button без aria-label
      document.querySelectorAll('[role="button"]:not([aria-label]):not([aria-labelledby])').forEach(element => {
        if (!element.textContent?.trim()) {
          element.setAttribute('aria-label', 'Интерактивный элемент');
        }
      });

      // Элементы с ролью menu без aria-label
      document.querySelectorAll('[role="menu"]:not([aria-label]):not([aria-labelledby])').forEach(menu => {
        menu.setAttribute('aria-label', 'Меню навигации');
      });

      // Элементы с ролью menuitem без aria-label
      document.querySelectorAll('[role="menuitem"]:not([aria-label]):not([aria-labelledby])').forEach(item => {
        if (!item.textContent?.trim()) {
          item.setAttribute('aria-label', 'Пункт меню');
        }
      });

      // Элементы с ролью tooltip без aria-label
      document.querySelectorAll('[role="tooltip"]:not([aria-label]):not([aria-labelledby])').forEach(tooltip => {
        tooltip.setAttribute('aria-label', 'Подсказка');
      });

      // Элементы с ролью dialog без aria-label
      document.querySelectorAll('[role="dialog"]:not([aria-label]):not([aria-labelledby])').forEach(dialog => {
        dialog.setAttribute('aria-label', 'Диалоговое окно');
      });

      // Элементы с ролью listbox без aria-label
      document.querySelectorAll('[role="listbox"]:not([aria-label]):not([aria-labelledby])').forEach(listbox => {
        listbox.setAttribute('aria-label', 'Список опций');
      });

      // Элементы с ролью option без aria-label
      document.querySelectorAll('[role="option"]:not([aria-label]):not([aria-labelledby])').forEach(option => {
        if (!option.textContent?.trim()) {
          option.setAttribute('aria-label', 'Опция списка');
        }
      });

      // Специфичные селекторы для HeroUI компонентов
      document.querySelectorAll('[data-slot="trigger"]:not([aria-label]):not([aria-labelledby])').forEach(trigger => {
        if (!trigger.textContent?.trim()) {
          trigger.setAttribute('aria-label', 'Триггер элемента');
        }
      });

      document.querySelectorAll('[data-slot="content"]:not([aria-label]):not([aria-labelledby])').forEach(content => {
        content.setAttribute('aria-label', 'Содержимое элемента');
      });

      // Input элементы без label
      document.querySelectorAll('input:not([aria-label]):not([aria-labelledby]):not([id])').forEach(input => {
        input.setAttribute('aria-label', 'Поле ввода');
      });

      // Span элементы с data-slot
      document.querySelectorAll('span[data-slot]:not([aria-label]):not([aria-labelledby])').forEach(span => {
        const htmlSpan = span as HTMLElement;
        if (!span.textContent?.trim() && htmlSpan.dataset.slot) {
          span.setAttribute('aria-label', `Элемент ${htmlSpan.dataset.slot}`);
        }
      });

      // Дополнительные селекторы для HeroUI компонентов
      document.querySelectorAll('[data-testid]:not([aria-label]):not([aria-labelledby])').forEach(element => {
        if (!element.textContent?.trim()) {
          element.setAttribute('aria-label', 'Элемент интерфейса');
        }
      });

      // Div элементы с классами HeroUI
      document.querySelectorAll('div[class*="nextui"]:not([aria-label]):not([aria-labelledby])').forEach(element => {
        if (!element.textContent?.trim() && element.getAttribute('role')) {
          element.setAttribute('aria-label', 'Компонент интерфейса');
        }
      });

      // Любые элементы с ролями без aria-label
      document.querySelectorAll('[role]:not([aria-label]):not([aria-labelledby])').forEach(element => {
        const role = element.getAttribute('role');
        if (!element.textContent?.trim() && role) {
          const roleLabels: { [key: string]: string } = {
            'presentation': 'Декоративный элемент',
            'separator': 'Разделитель',
            'group': 'Группа элементов',
            'region': 'Область контента',
            'complementary': 'Дополнительная информация',
            'banner': 'Баннер',
            'contentinfo': 'Информация о контенте',
            'navigation': 'Навигация',
            'search': 'Поиск',
            'main': 'Основной контент'
          };
          
          const label = roleLabels[role] || `Элемент с ролью ${role}`;
          element.setAttribute('aria-label', label);
        }
      });
    } catch (error) {
      console.warn('Ошибка при добавлении aria-label:', error);
    }
  }, 100);
}; 